<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <g clip-path="url(#clip0_322_307)">
      <circle cx="12" cy="12" r="12" fill="#09A684" />
      <path
        d="M22.8571 12C22.8571 6.00377 17.9962 1.14286 12 1.14286C6.00377 1.14286 1.14286 6.00377 1.14286 12C1.14286 17.9962 6.00377 22.8571 12 22.8571C17.9962 22.8571 22.8571 17.9962 22.8571 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12Z"
        fill="#A9DCD6"
      />
      <path
        d="M12.5789 11.4361L20.0806 11.4286C20.3962 11.4283 20.6523 11.6839 20.6526 11.9995C20.653 12.3151 20.3974 12.5712 20.0818 12.5715L12.0086 12.5795C11.693 12.5799 11.4369 12.3243 11.4366 12.0087L11.4286 3.91941C11.4283 3.60382 11.6838 3.34773 11.9994 3.34741C12.315 3.3471 12.5711 3.60268 12.5714 3.91827L12.5789 11.4361Z"
        fill="white"
      />
      <path
        d="M11.4211 12.564L3.91935 12.5715C3.60376 12.5718 3.34767 12.3162 3.34735 12.0006C3.34704 11.685 3.60262 11.4289 3.91821 11.4286L11.9914 11.4206C12.307 11.4203 12.5631 11.6758 12.5634 11.9914L12.5714 20.0807C12.5717 20.3963 12.3162 20.6524 12.0006 20.6527C11.685 20.653 11.4289 20.3974 11.4286 20.0819L11.4211 12.564Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_322_307">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
  export default {
    name: 'IconAddAAG',
    props: {
      color: {
        type: String,
        default: '#585B60',
      },
    }
  };
</script>

<style lang="scss" scoped></style>
